import { render, staticRenderFns } from "./actions-column.vue?vue&type=template&id=a7aa8212&scoped=true"
import script from "./actions-column.vue?vue&type=script&lang=js"
export * from "./actions-column.vue?vue&type=script&lang=js"
import style0 from "./actions-column.vue?vue&type=style&index=0&id=a7aa8212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7aa8212",
  null
  
)

export default component.exports